<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.gift.pass.complete.title')" :header-back-route="homeRoute">
    <b-container v-if="customerPass"class="mt-12">
      <b-summary>
        <template #summary>
          <b-card class="text-secondary">
            <img v-if="customerPass.gift && passImage" :src="passImage" class="mb-4 rounded" />

            <div v-if="customerPass.gift.to" class="mb-1">
              <strong>{{ customerPass.gift.to.name }},</strong>
            </div>
            <div v-if="customerPass.gift.message">
              {{ customerPass.gift.message }}
            </div>
            <div v-if="customerPass.gift.from" class="mt-3">
              <strong>{{ customerPass.gift.from.name }}</strong>
            </div>
            <hr>
            <h3  class="font-semibold text-xl mt-6 mb-6">
              {{ customerPass.pass.name }}
            </h3>
            <h6 class="text-xs font-weight-light mb-2">
              {{ $site.location.title }}
            </h6>
          </b-card>
        </template>

        <div>
          <b-card :title="$t('pages.gift.pass.complete.allDone')" class="mb-3 text-sm text-secondary">
            <p class="mb-2" v-html="$t('pages.gift.pass.complete.thanksCustomer',{name: customerPass.gift.from.name})" />

            <p v-if="customerPass.gift.deliveryDate" class="mb-4" v-html="$t('pages.gift.pass.complete.deliveredToDate',{name: customerPass.gift.to.name, email: customerPass.gift.to.email, date: $format.date(customerPass.gift.deliveryDate)})" />
            <p v-else class="mb-4" v-html="$t('pages.gift.pass.complete.deliveredTo',{name: customerPass.gift.to.name, email: customerPass.gift.to.email})" />

            <p v-html="$t('pages.gift.pass.complete.receiptEmailed')" />
          </b-card>
        </div>
      </b-summary>
    </b-container>
  </b-layout>
</template>

<script setup>
definePageMeta({
  tabs: ['giftCard']
})

const route = useRoute()
const { $api, $site, $format } = useNuxtApp()
const layoutStore = useLayoutStore()

const { data: customerPassData } = await useAsyncData(
  'customerPass',
  () => $api.pass.customerPass(route.query.id, route.query.signature)
)

const customerPass = computed(() => customerPassData.value?.customerPass)

const homeRoute = computed(() => layoutStore.homeRoute || { path: '/' })

const passImage = computed(() => {
  if (!customerPass.value) return null
  
  if (customerPass.value.images) {
    return customerPass.value.images.large
  } else if ($site.images.pass) {
    return $site.images.pass.large
  }
  return null
})

onMounted(() => {
  if ($site.isEmbed && window.parent) {
    window.postRobot?.send(window.parent, 'bookapp.event.gift.pass.purchased', customerPass.value)
  }
  
  const { gtag } = useGtag()
  
  gtag(
    'event',
    'complete_gift_pass_purchase',
    {
      event_category: 'purchase',
      event_label: 'New Gift Pass Purchase'
    }
  )
})
</script>
